var React = require('react');

function WhitelistIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E5E5E5","fillRule":"nonzero","d":"M2.707 7.293L1.293 8.707 6 13.414l9.707-9.707-1.414-1.414L6 10.586z"}));
}

WhitelistIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 16 16"};

module.exports = WhitelistIcon;

WhitelistIcon.default = WhitelistIcon;
